const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  },
  {
    id: '#cart-counter-new',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #cart-counter-new'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.querySelector('.cart-drawer__inner').setAttribute('aria-hidden', 'false');

    this.addEventListener('transitionend', () => {
      this.focusOnCartDrawer();
    }, { once: true });

    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    this.toggleChat(false);
  }

  close() {
    this.classList.remove('is-visible');
    document.body.classList.remove('cart-drawer-open');
    this.toggleChat(true);
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    document.body.classList.remove('overflow-hidden');

    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  toggleChat(show) {
    const chatWidgets = document.querySelectorAll(
      '#shopify-chat, #ShopifyChat, shopify-chat, #dummy-chat-button-iframe, iframe#dummy-chat-button-iframe, iframe[title*="chat" i], iframe[title*="inbox" i], iframe[name*="chat" i]'
    );

    chatWidgets.forEach((widget) => {
      if (show) {
        widget.style.removeProperty('display');
        widget.style.removeProperty('visibility');
        widget.style.removeProperty('opacity');
        widget.removeAttribute('hidden');
      } else {
        widget.style.setProperty('display', 'none', 'important');
        widget.style.setProperty('visibility', 'hidden', 'important');
        widget.style.setProperty('opacity', '0', 'important');
        widget.setAttribute('hidden', '');
      }
    });
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  focusOnCartDrawer() {
    const cartDrawer = this.querySelector('.cart-drawer');
    if (cartDrawer) {
      // cartDrawer.setAttribute('tabindex', '0');
      cartDrawer.focus();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// NEW CODE 
function initInstructionSwiper() {
  document.querySelectorAll('.instruction-slider').forEach((slider) => {
    if (slider.swiper) return;

    const options = slider.dataset.swiperOptions
      ? JSON.parse(slider.dataset.swiperOptions)
      : {};

    new Swiper(slider, options);
  });
}

document.addEventListener('DOMContentLoaded', initInstructionSwiper);

document.addEventListener('cart:open', initInstructionSwiper);

document.addEventListener('cart:refresh', initInstructionSwiper);

